__turbopack_context__.v({
  "className": "space_grotesk_f9251318-module__ivSPtG__className",
});
